/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsformsortFormsortIntegration1 from './IntegrationsformsortFormsortIntegration1';

/**
 * The IntegrationsFormsortBody1 model module.
 * @module model/IntegrationsFormsortBody1
 * @version v0.3
 */
export default class IntegrationsFormsortBody1 {
  /**
   * Constructs a new <code>IntegrationsFormsortBody1</code>.
   * @alias module:model/IntegrationsFormsortBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsFormsortBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsFormsortBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsFormsortBody1} The populated <code>IntegrationsFormsortBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsFormsortBody1();
      if (data.hasOwnProperty('formsort_integration'))
        obj.formsortIntegration = IntegrationsformsortFormsortIntegration1.constructFromObject(data['formsort_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsformsortFormsortIntegration1} formsortIntegration
 */
IntegrationsFormsortBody1.prototype.formsortIntegration = undefined;

